// The issue types the Product Profile can actually resolve in-page, and the
// copy the Issues card / Fix dialog render for each.
//
// `label` titles the Issues card row, `fieldLabel` names the control in the Fix
// dialog, and `field` is the applyFix target (see the refs in ProductDetail).
// Issue types absent from this map (e.g. MissingDeliveryCategories,
// InvalidCondition) have no remedy on this page, so they're filtered out of the
// Issues card and never raise a Fix affordance.
export const FIXABLE_ISSUES = {
	MissingProductTitle: {
		field: 'title',
		label: 'Missing title',
		fieldLabel: 'Product title',
		reason: 'A descriptive title helps shoppers and channel algorithms find your product.',
		steps: 'Write a clear title including brand, product type and key attributes (e.g. size, colour).',
		cta: 'Edit title'
	},
	MissingProductImages: {
		field: 'image',
		label: 'Missing image',
		fieldLabel: 'Product image',
		reason: 'A clear main image is required for shoppers to see your product.',
		steps: 'Upload a high-quality image (min. 800×800px, white or plain background, no watermarks).',
		cta: 'Upload image'
	},
	MissingProductDescription: {
		field: 'description',
		label: 'Missing description',
		fieldLabel: 'Description',
		reason: 'A short description improves ranking and shopper confidence.',
		steps: 'Add 1–3 sentences describing what the product is and its main features.',
		cta: 'Add description'
	},
	MissingProductBrand: {
		field: 'brand',
		label: 'Missing brand',
		fieldLabel: 'Brand',
		reason: 'Brand is used to match your product against manufacturer data.',
		steps: 'Add the manufacturer brand name exactly as it appears on the packaging.',
		cta: 'Add brand'
	},
	MissingProductCategory: {
		field: 'category',
		label: 'Missing category',
		fieldLabel: 'Category',
		reason: 'A valid category is needed so the product appears in the right feed.',
		steps: "Select the most specific category from Google's product taxonomy.",
		cta: 'Select category'
	}
};

// Order the Issues card lists rows in, and the order a channel's Fix button
// picks which issue to open first. Title leads because it's the only issue the
// title-floor channels block on; the rest follow the shopper-impact order the
// design's copy implies.
export const ISSUE_PRIORITY = [
	'MissingProductTitle',
	'MissingProductImages',
	'MissingProductDescription',
	'MissingProductBrand',
	'MissingProductCategory'
];

export const sortIssueTypes = (types) => [...types].sort((a, b) => ISSUE_PRIORITY.indexOf(a) - ISSUE_PRIORITY.indexOf(b));
